import { FunctionComponent } from 'react';
import { EmbedBlockModel } from '../../../../services/content/articleBody/models/EmbedBlockModel';
import styles from './EmbedBlock.module.scss';
import {
    getInstagramPermaLink,
    isFacebookEmbedVideo,
    isFacebookVideoPortrait,
    isIframeVideo,
    isInstagramEmbed,
} from '../../../../services/social/General';
import { InstagramEmbed } from 'react-social-media-embed/dist/components/embeds/InstagramEmbed';

type Props = {
    embedBlock: EmbedBlockModel;
};

export const EmbedBlock: FunctionComponent<Props> = ({ embedBlock }) => {
    //Adding try catch in case there is a faulty embed code added in the CMS
    try {
        let embed = embedBlock.data.content;

        if (isInstagramEmbed(embed)) {
            const postUrl = getInstagramPermaLink(embed);
            return (
                <div className={styles.instagramContainer}>
                    <InstagramEmbed width={500} url={postUrl} />
                </div>
            );
        }

        return (
            <div
                className={`d-flex flex-row justify-content-center mt-3 mb-3 ${getIframeStyling(embed)}`}
                dangerouslySetInnerHTML={{ __html: embed }}></div>
        );
    } catch (e) {
        return null;
    }
};

const getIframeStyling = (iframeUrl: string) => {
    if (isFacebookEmbedVideo(iframeUrl) && isFacebookVideoPortrait(iframeUrl)) {
        return '';
    }

    if (isIframeVideo(iframeUrl)) {
        return styles.iframeContainer;
    }

    return '';
};
